// removed by extract-text-webpack-plugin
module.exports = {"legendContainer":"src-components----Legend-module---legendContainer---3Jo3R","legend":"src-components----Legend-module---legend---1gI61","color":"src-components----Legend-module---color---NuevE","title":"src-components----Legend-module---title---3ptJN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Legend.module.css
// module id = 135
// module chunks = 168707334958949